(ns io.repliance.util.token-bucket
  "Token bucket rate limiter. Allows actions at a per second rate and also with a burst.

  Adapted from various sources, for example https://github.com/falconry/token-bucket/blob/1f3100081dd8eea1fe6526821f5d7e358fa459fc/token_bucket/storage.py#L118")

(def now-millis
  "Function that returns current time in milliseconds"
  #?(:cljs js/Date.now
     :clj #(System/currentTimeMillis)))

(defn make-token-bucket
  "Makes a token bucket with `capacity` and refill rate `fill-per-second`.

  Store the result into an atom for use with `consume`"
  [capacity fill-per-second]
  {:capacity capacity
   :fill-per-second fill-per-second
   :last-filled (now-millis)
   :tokens capacity
   :accept-take true})

(defn refill-and-take
  "Refill the bucket and take a token. Use `:accept-take` to allow/deny action after this call"
  [{:keys [fill-per-second capacity
           last-filled tokens]
    :as token-bucket}]
  (let [now (now-millis)
        millis-since-last-fill (- now last-filled)
        fill (* (/ fill-per-second 1000) millis-since-last-fill)
        ;; Leaky bucket, limit tokens to capacity
        tokens (min capacity (+ tokens fill))
        ;; Allow to take a token if tokens available
        accept-take (> tokens 0)]
    (assoc token-bucket
           :fill fill
           ;; Take one token
           :tokens (if accept-take
                     (dec tokens)
                     tokens)
           :last-filled now
           ;; Take was accepted if we took a token
           :accept-take accept-take)))

(defn consume
  "Consumes the bucket inside an atom.
  Returns `true` if action should be allowed, `false` if denied"
  [token-bucket-atom]
  (:accept-take (swap! token-bucket-atom refill-and-take)))

(defn make-rate-limited-fn
  "Make a rate limited function, calls will be skipped when exceeding the token bucket rate limit"
  [token-bucket-atom f]
  (fn [& args]
    (when (consume token-bucket-atom)
      (apply f args))))

#?(:clj
   (comment
     (def bucket-atom (atom (make-token-bucket 10 2)))
     (add-watch bucket-atom :debug (fn [_ref _key _old new]
                                     (println (format "tokens: %f, fill: %f"
                                                      (float (:tokens new))
                                                      (float (:fill new))))))
     (def f (make-rate-limited-fn bucket-atom #(println "Called")))
     (def worker (future
                   (while (not (.isInterrupted (Thread/currentThread)))
                     (f)
                     (Thread/sleep 200))))
     (future-cancel worker)))
